import React, { useState } from 'react';
import { THEME } from '../../constants/theme';
import ETOCases from './ETOCases';
import ETOAgents from './ETOAgents';

const ETOPanel = ({ initialSubTab }) => {
    const [activeTab, setActiveTab] = useState('cases');

    const actionToPass = initialSubTab === 'add_case' ? 'add_case' : null;

    return (
        <div style={{ padding: '10px' }}>
            <div style={{ display: 'flex', gap: '15px', borderBottom: '2px solid #e2e8f0', marginBottom: '25px' }}>
                <button
                    onClick={() => setActiveTab('cases')}
                    style={{
                        padding: '12px 24px',
                        border: 'none',
                        background: 'none',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: activeTab === 'cases' ? THEME.secondary || '#2563eb' : '#64748b',
                        borderBottom: activeTab === 'cases' ? `3px solid ${THEME.secondary || '#2563eb'}` : 'none',
                        transition: '0.2s'
                    }}
                >
                    📁 ETO Cases
                </button>
                <button
                    onClick={() => setActiveTab('agents')}
                    style={{
                        padding: '12px 24px',
                        border: 'none',
                        background: 'none',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: activeTab === 'agents' ? THEME.secondary || '#2563eb' : '#64748b',
                        borderBottom: activeTab === 'agents' ? `3px solid ${THEME.secondary || '#2563eb'}` : 'none',
                        transition: '0.2s'
                    }}
                >
                    👥 ETO Agents
                </button>
            </div>

            {activeTab === 'cases' && <ETOCases initialAction={actionToPass} />}
            {activeTab === 'agents' && <ETOAgents />}
        </div>
    );
};

export default ETOPanel;